<!-- 新手引导 -->
<template>
  <van-dialog
    v-model="show"
    className="welcome"
  >
    <img :src="WelcomeImg" alt="">
    <div class="welconme-content-top">
      <div class="welconme-content-top-icon">
        <svg
          class="icon"
          aria-hidden="true"
        >
          <use xlink:href="#icongongxininchengweizunguidetuiguanghehuoren"></use>
        </svg>
      </div>
      <div class="welconme-content-top-text">
        通过合伙人邀请注册的会员均可领取5万美元免手续费入账额度卡！更多推广奖励等你拿！
      </div>
    </div>
    <van-button
      class="welconme-content-btn"
      @click="show = false"
    >
      {{ $t('app.word.confirm') }}
    </van-button>
  </van-dialog>
</template>
<script>
import WelcomeImg from '@/assets/images/home/welcome.png'
export default {
  name: 'welcome',
  data() {
    return {
      show: false,
      WelcomeImg
    }
  }

}
</script>

<style lang="less" scoped>
  .welcome {
    border-radius: 10px;
    width: 93vw;
    /deep/.van-dialog__content {
      box-sizing: border-box;
      font-size: 0;
      position: relative;
    }
    /deep/.van-dialog__footer {
      display: none;
    }
    .welconme-content-top {
      width: 100%;
      box-sizing: border-box;
      padding: 24px;
      position: absolute;
      left: 0;
      top: 0;
      .welconme-content-top-icon {
        width: 100%;
        height: calc(31vw - 16px);
        display: flex;
        align-items:  center;
        justify-content: center;
      }
      .icon {
        width: 100%;
        height: auto;
        transform: translateX(-2%);
      }
      .welconme-content-top-text {
        font-size:14px;
        padding-top: 10px;
        color: #fff;
        line-height: 24px;
      }
    }
    img {
      width: 100%;
    }
    .welconme-content-btn {
      width:223px;
      height:44px;
      background: #ffdd3f;
      font-size: 16px;
      color: #121212;
      border-radius:25px;
      position: absolute;
      bottom: 38px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>
